import { InstacallComponent } from "../../features/instacall/instacall.component";
import { DialpadComponent } from "../../features/instacall/dialpad/dialpad.component";
import { DialpadButtonComponent } from "../../features/instacall/dialpad/dialpadButton.component";
import { VolumeComponent } from "../../features/instacall/volume/volume.component";

import { PipesModule } from "../../features/shared/pipes/pipes.module";
import { DialpadModule } from "../../features/shared/components/dialpad/dialpad.module";
import { CallVideoContainerModule } from "../../features/call/video/call-video-container.module";

import { CoreModule } from "../../../common/modules/core/core.module";
import { ConsoleService } from "../../../common/services/console/console.service";
import { LocalizationService } from "../../../common/services/localization.service";
import { LogTarget } from "../../../common/services/logging/log.target";
import { cons, consoleLogTarget } from "../app.config";

import { LOCALE_ID, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { HttpClient, provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RouterModule } from "@angular/router";
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";

import { WebApiSessionService } from "../../features/shared/services/webApiSession/web-api-session.service";
import { ApiSessionService } from "../../../common/services/api/api-session.service";
import { WebNetworkService } from "../../features/shared/services/webNetwork/web-network.service";
import { NetworkService } from "../../../common/services/network.service";

// i18n mobile translations imports
import { CustomTranslateLoader } from "../../i18n/translate-loader";

// for AoT compilation
export function LoaderFactory() {
  return new CustomTranslateLoader();
}

@NgModule({
  imports: [
    BrowserModule,
    CommonModule,
    FormsModule,
    CoreModule.forRoot([
      { provide: ConsoleService, useFactory: cons },
      { provide: LogTarget, useFactory: consoleLogTarget, deps: [ConsoleService], multi: true }
    ]),
    PipesModule,
    DialpadModule,
    CallVideoContainerModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: LoaderFactory,
        deps: [HttpClient]
      }
    }),
    RouterModule.forRoot([], { initialNavigation: "disabled" })
  ],
  declarations: [InstacallComponent, VolumeComponent, DialpadComponent, DialpadButtonComponent],
  bootstrap: [InstacallComponent],
  providers: [
    { provide: ApiSessionService, useClass: WebApiSessionService },
    { provide: NetworkService, useClass: WebNetworkService },
    {
      provide: LOCALE_ID,
      deps: [LocalizationService],
      useFactory: (localizationService: LocalizationService) => localizationService.getLocale()
    },
    provideHttpClient(withInterceptorsFromDi())
  ]
})
export class InstacallApp {}
